// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-item {
  overflow: hidden;
}
.property-item .thumbnail-section {
  position: relative;
}
.property-item .mat-card-image {
  position: relative;
  min-height: 207px;
}
.property-item .mat-card-image .swiper-container .swipe-arrow {
  color: #fff;
}
.property-item .mat-card-image .swiper-container .swipe-arrow.swiper-button-next {
  right: 4px;
}
.property-item .mat-card-image .swiper-container .swipe-arrow.swiper-button-prev {
  left: 4px;
}
.property-item .mat-card-image .swiper-slide {
  text-align: center;
  padding-bottom: 66.25%;
  position: relative;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
}
.property-item .mat-card-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
}
.property-item .property-status {
  position: absolute;
  z-index: 2;
}
.property-item .property-status span {
  padding: 3px 6px;
  margin: 4px;
  font-size: 12px;
  color: #fff;
  text-transform: uppercase;
  border-radius: 4px;
}
.property-item .title {
  font-size: 18px;
}
.property-item .title a {
  transition: 0.2s;
  text-decoration: none;
}
.property-item .address,
.property-item .date {
  font-style: italic;
  margin-top: 8px;
}
.property-item .address .mat-icon,
.property-item .date .mat-icon {
  margin-left: -4px;
}
.property-item .price span {
  display: block;
}
.property-item .features p span:first-child {
  float: left;
  padding: 0 0.4em 0 0;
}
.property-item .features p span + span {
  float: right;
  padding: 0 0 0 0.4em;
}
.property-item .features p:after {
  content: "";
  display: block;
  overflow: hidden;
  height: 1em;
}
.property-item .control-icons {
  position: absolute;
  z-index: 2;
  right: 2px;
  margin-top: -30px;
}
.property-item .control-icons button.mat-button {
  min-width: 26px;
  width: 26px;
  line-height: 26px;
  padding: 0;
  margin: 0 4px;
  background: rgba(255, 252, 252, 0.6);
  transition: 0.2s;
  color: rgba(0, 0, 0, 0.87);
}
.property-item .control-icons button.mat-button:disabled {
  color: rgba(0, 0, 0, 0.26);
}
.property-item .control-icons button.mat-button:hover:enabled {
  background: rgb(255, 252, 252);
}
.property-item.grid-item {
  flex-flow: column !important;
}
.property-item.grid-item.column-2 .title {
  font-size: 22px;
}
.property-item.grid-item.column-2 .price {
  font-size: 18px;
}
.property-item.grid-item.column-3 .title {
  font-size: 18px;
}
.property-item.grid-item.column-3 .address .mat-icon,
.property-item.grid-item.column-3 .date .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.property-item.grid-item.full-width-page.column-2 .title {
  font-size: 28px;
}
.property-item.grid-item.full-width-page.column-2 .price {
  font-size: 20px;
}
.property-item.grid-item.full-width-page.column-3 .title {
  font-size: 22px;
}
.property-item.grid-item.full-width-page.column-3 .address,
.property-item.grid-item.full-width-page.column-3 .date {
  font-size: 14px;
}
.property-item.grid-item.full-width-page.column-3 .address .mat-icon,
.property-item.grid-item.full-width-page.column-3 .date .mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.property-item.grid-item.full-width-page.column-3 .price {
  font-size: 18px;
}
.property-item.grid-item.full-width-page.column-4 .title {
  font-size: 18px;
}
.property-item.grid-item.full-width-page.column-4 .address .mat-icon,
.property-item.grid-item.full-width-page.column-4 .date .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.property-item.list-item .title {
  font-size: 28px;
  margin-top: -8px;
}
.property-item.list-item .price {
  font-size: 20px;
}
.property-item.list-item .features {
  display: flex;
  flex-flow: wrap;
}
.property-item.list-item .features p {
  margin-right: 24px;
  display: flex;
  white-space: nowrap;
}
.property-item.list-item .features p span:first-child:after {
  content: ":";
  margin: 0 1px;
}
.property-item.list-item .features p:after {
  content: none;
}

button.mat-button {
  min-width: 26px;
  width: 26px;
  line-height: 26px;
  padding: 0;
  margin: 0 4px;
  background: rgba(255, 252, 252, 0.6) !important;
  transition: 0.2s;
  color: rgba(0, 0, 0, 0.87);
}
button.mat-button:disabled {
  color: rgba(0, 0, 0, 0.26);
}
button.mat-button:hover:enabled {
  background: rgb(255, 252, 252) !important;
}

@media screen and (max-width: 959px) {
  .property-item {
    min-height: 250px !important;
  }
  .property-item.grid-item .title {
    font-size: 22px;
  }
  .property-item.grid-item.column-2 .title {
    font-size: 22px;
  }
  .property-item.grid-item.full-width-page.column-2 .title {
    font-size: 22px;
  }
  .property-item.list-item .title {
    font-size: 22px;
  }
  .property-item.list-item .address .mat-icon,
  .property-item.list-item .date .mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .property-item.list-item .price {
    font-size: 18px;
  }
}
.c-byggingargerd {
  font-size: 14px;
}

.c-price {
  font-weight: bold;
  float: left;
  margin-top: 3px;
}

.mat-mdc-icon-button {
  --mat-mdc-button-persistent-ripple-color: transparent !important;
}

.c-location-icon {
  width: 34px !important;
  height: 40px !important;
  font-size: 30px !important;
  margin-left: 3px !important;
  margin-top: 3px !important;
}

.mblInject .primary-color {
  color: rgba(0, 0, 0, 0.87) !important;
}
.mblInject .primary-color p,
.mblInject .primary-color h1,
.mblInject .primary-color h2,
.mblInject .primary-color h3,
.mblInject .primary-color h4,
.mblInject .primary-color h5,
.mblInject .primary-color h6,
.mblInject .primary-color span,
.mblInject .primary-color li,
.mblInject .primary-color a,
.mblInject .primary-color label,
.mblInject .primary-color strong,
.mblInject .primary-color em,
.mblInject .primary-color small,
.mblInject .primary-color i,
.mblInject .primary-color i::before {
  color: rgba(0, 0, 0, 0.87) !important;
}

.property-title {
  line-height: 1.3 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/property-item-sold/property-item-sold.component.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,kBAAA;EACA,iBAAA;AAFJ;AAKM;EACE,WAAA;AAHR;AAKQ;EACE,UAAA;AAHV;AAMQ;EACE,SAAA;AAJV;AASI;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;AAPN;AAUI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AARN;AAYE;EACE,kBAAA;EACA,UAAA;AAVJ;AAYI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAVN;AAcE;EACE,eAAA;AAZJ;AAcI;EACE,gBAAA;EACA,qBAAA;AAZN;AAgBE;;EAEE,kBAAA;EACA,eAAA;AAdJ;AAgBI;;EACE,iBAAA;AAbN;AAkBI;EACE,cAAA;AAhBN;AAsBM;EACE,WAAA;EACA,oBAAA;AApBR;AAuBM;EACE,YAAA;EACA,oBAAA;AArBR;AAyBI;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AAvBN;AA2BE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;AAzBJ;AA2BI;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,0BAAA;AAzBN;AA2BM;EACE,0BAAA;AAzBR;AA4BM;EACE,8BAAA;AA1BR;AA+BE;EACE,4BAAA;AA7BJ;AAgCM;EACE,eAAA;AA9BR;AAiCM;EACE,eAAA;AA/BR;AAoCM;EACE,eAAA;AAlCR;AAwCQ;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArCV;AA4CQ;EACE,eAAA;AA1CV;AA6CQ;EACE,eAAA;AA3CV;AAgDQ;EACE,eAAA;AA9CV;AAiDQ;;EAEE,eAAA;AA/CV;AAiDU;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9CZ;AAkDQ;EACE,eAAA;AAhDV;AAqDQ;EACE,eAAA;AAnDV;AAyDU;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtDZ;AA8DI;EACE,eAAA;EACA,gBAAA;AA5DN;AA+DI;EACE,eAAA;AA7DN;AAgEI;EACE,aAAA;EACA,eAAA;AA9DN;AAgEM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA9DR;AAgEQ;EACE,YAAA;EACA,aAAA;AA9DV;AAiEQ;EACE,aAAA;AA/DV;;AAsEA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,+CAAA;EACA,gBAAA;EACA,0BAAA;AAnEF;AAqEE;EACE,0BAAA;AAnEJ;AAsEE;EACE,yCAAA;AApEJ;;AAwEA;EACE;IACE,4BAAA;EArEF;EA0EI;IACE,eAAA;EAxEN;EA4EM;IACE,eAAA;EA1ER;EAgFQ;IACE,eAAA;EA9EV;EAqFI;IACE,eAAA;EAnFN;EAyFM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAtFR;EA0FI;IACE,eAAA;EAxFN;AACF;AA6FA;EACE,eAAA;AA3FF;;AA8FA;EACE,iBAAA;EACA,WAAA;EACA,eAAA;AA3FF;;AA+FA;EACE,gEAAA;AA5FF;;AA+FA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;AA5FF;;AAiGA;EACE,qCAAA;AA9FF;AAgGE;;;;;;;;;;;;;;;;EAgBE,qCAAA;AA9FJ;;AAkGA;EACE,2BAAA;AA/FF","sourcesContent":["@import \"../../../styles/variables.scss\";\r\n\r\n.property-item {\r\n  overflow: hidden;\r\n\r\n  .thumbnail-section {\r\n    position: relative;\r\n  }\r\n\r\n  .mat-card-image {\r\n    position: relative;\r\n    min-height: 207px;\r\n\r\n    .swiper-container {\r\n      .swipe-arrow {\r\n        color: #fff;\r\n\r\n        &.swiper-button-next {\r\n          right: 4px;\r\n        }\r\n\r\n        &.swiper-button-prev {\r\n          left: 4px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .swiper-slide {\r\n      text-align: center;\r\n      padding-bottom: 66.25%;\r\n      position: relative;\r\n      overflow: hidden;\r\n      background: rgba(0, 0, 0, 0.04);\r\n    }\r\n\r\n    img {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: auto;\r\n    }\r\n  }\r\n\r\n  .property-status {\r\n    position: absolute;\r\n    z-index: 2;\r\n\r\n    span {\r\n      padding: 3px 6px;\r\n      margin: 4px;\r\n      font-size: 12px;\r\n      color: #fff;\r\n      text-transform: uppercase;\r\n      border-radius: 4px;\r\n    }\r\n  }\r\n\r\n  .title {\r\n    font-size: 18px;\r\n\r\n    a {\r\n      transition: 0.2s;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n\r\n  .address,\r\n  .date {\r\n    font-style: italic;\r\n    margin-top: 8px;\r\n\r\n    .mat-icon {\r\n      margin-left: -4px;\r\n    }\r\n  }\r\n\r\n  .price {\r\n    span {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .features p {\r\n    span {\r\n      &:first-child {\r\n        float: left;\r\n        padding: 0 0.4em 0 0;\r\n      }\r\n\r\n      +span {\r\n        float: right;\r\n        padding: 0 0 0 0.4em;\r\n      }\r\n    }\r\n\r\n    &:after {\r\n      content: \"\";\r\n      display: block;\r\n      overflow: hidden;\r\n      height: 1em;\r\n    }\r\n  }\r\n\r\n  .control-icons {\r\n    position: absolute;\r\n    z-index: 2;\r\n    right: 2px;\r\n    margin-top: -30px;\r\n\r\n    button.mat-button {\r\n      min-width: 26px;\r\n      width: 26px;\r\n      line-height: 26px;\r\n      padding: 0;\r\n      margin: 0 4px;\r\n      background: rgba(255, 252, 252, 0.6);\r\n      transition: 0.2s;\r\n      color: rgba(0, 0, 0, 0.87);\r\n\r\n      &:disabled {\r\n        color: rgba(0, 0, 0, 0.26);\r\n      }\r\n\r\n      &:hover:enabled {\r\n        background: rgba(255, 252, 252, 1);\r\n      }\r\n    }\r\n  }\r\n\r\n  &.grid-item {\r\n    flex-flow: column !important;\r\n\r\n    &.column-2 {\r\n      .title {\r\n        font-size: 22px;\r\n      }\r\n\r\n      .price {\r\n        font-size: 18px;\r\n      }\r\n    }\r\n\r\n    &.column-3 {\r\n      .title {\r\n        font-size: 18px;\r\n      }\r\n\r\n      .address,\r\n      .date {\r\n\r\n        .mat-icon {\r\n          font-size: 18px;\r\n          width: 18px;\r\n          height: 18px;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.full-width-page {\r\n      &.column-2 {\r\n        .title {\r\n          font-size: 28px;\r\n        }\r\n\r\n        .price {\r\n          font-size: 20px;\r\n        }\r\n      }\r\n\r\n      &.column-3 {\r\n        .title {\r\n          font-size: 22px;\r\n        }\r\n\r\n        .address,\r\n        .date {\r\n          font-size: 14px;\r\n\r\n          .mat-icon {\r\n            font-size: 24px;\r\n            width: 24px;\r\n            height: 24px;\r\n          }\r\n        }\r\n\r\n        .price {\r\n          font-size: 18px;\r\n        }\r\n      }\r\n\r\n      &.column-4 {\r\n        .title {\r\n          font-size: 18px;\r\n        }\r\n\r\n        .address,\r\n        .date {\r\n\r\n          .mat-icon {\r\n            font-size: 18px;\r\n            width: 18px;\r\n            height: 18px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.list-item {\r\n    .title {\r\n      font-size: 28px;\r\n      margin-top: -8px;\r\n    }\r\n\r\n    .price {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .features {\r\n      display: flex;\r\n      flex-flow: wrap;\r\n\r\n      p {\r\n        margin-right: 24px;\r\n        display: flex;\r\n        white-space: nowrap;\r\n\r\n        span:first-child:after {\r\n          content: \":\";\r\n          margin: 0 1px;\r\n        }\r\n\r\n        &:after {\r\n          content: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nbutton.mat-button {\r\n  min-width: 26px;\r\n  width: 26px;\r\n  line-height: 26px;\r\n  padding: 0;\r\n  margin: 0 4px;\r\n  background: rgba(255, 252, 252, 0.6) !important;\r\n  transition: 0.2s;\r\n  color: rgba(0, 0, 0, 0.87);\r\n\r\n  &:disabled {\r\n    color: rgba(0, 0, 0, 0.26);\r\n  }\r\n\r\n  &:hover:enabled {\r\n    background: rgba(255, 252, 252, 1) !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 959px) {\r\n  .property-item {\r\n    min-height: 250px !important;\r\n  }\r\n\r\n  .property-item {\r\n    &.grid-item {\r\n      .title {\r\n        font-size: 22px;\r\n      }\r\n\r\n      &.column-2 {\r\n        .title {\r\n          font-size: 22px;\r\n        }\r\n      }\r\n\r\n      &.full-width-page {\r\n        &.column-2 {\r\n          .title {\r\n            font-size: 22px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    &.list-item {\r\n      .title {\r\n        font-size: 22px;\r\n      }\r\n\r\n      .address,\r\n      .date {\r\n\r\n        .mat-icon {\r\n          font-size: 18px;\r\n          width: 18px;\r\n          height: 18px;\r\n        }\r\n      }\r\n\r\n      .price {\r\n        font-size: 18px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.c-byggingargerd {\r\n  font-size: 14px;\r\n}\r\n\r\n.c-price {\r\n  font-weight: bold;\r\n  float: left;\r\n  margin-top: 3px;\r\n}\r\n\r\n\r\n.mat-mdc-icon-button {\r\n  --mat-mdc-button-persistent-ripple-color: transparent !important;\r\n}\r\n\r\n.c-location-icon {\r\n  width: 34px !important;\r\n  height: 40px !important;\r\n  font-size: 30px !important;\r\n  margin-left: 3px !important;\r\n  margin-top: 3px !important;\r\n}\r\n\r\n// MBL styles\r\n\r\n.mblInject .primary-color {\r\n  color: $main-text-color !important;\r\n\r\n  p,\r\n  h1,\r\n  h2,\r\n  h3,\r\n  h4,\r\n  h5,\r\n  h6,\r\n  span,\r\n  li,\r\n  a,\r\n  label,\r\n  strong,\r\n  em,\r\n  small,\r\n  i,\r\n  i::before {\r\n    color: $main-text-color !important;\r\n  }\r\n}\r\n\r\n.property-title {\r\n  line-height: 1.3 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
